import { ApiPremiumDeterminingFactorIdEnum, FactorIdEnum } from 'outshared-lib';

// Move to data libary
export function mapFactorIdRequest(factorId: FactorIdEnum): ApiPremiumDeterminingFactorIdEnum {
    switch (factorId) {
        case FactorIdEnum.DamageFreeYears:
            return ApiPremiumDeterminingFactorIdEnum.DamageFreeYears;
        case FactorIdEnum.BonusMalusStep:
            return ApiPremiumDeterminingFactorIdEnum.BonusMalusStep;
        case FactorIdEnum.KilometerPerYearCar:
            return ApiPremiumDeterminingFactorIdEnum.KilometerPerYearCar;
        case FactorIdEnum.PostalcodeRateMoped:
            return ApiPremiumDeterminingFactorIdEnum.PostalcodeRateMoped;
        case FactorIdEnum.FuelMoped:
            return ApiPremiumDeterminingFactorIdEnum.FuelMoped;
        case FactorIdEnum.HailroofIndication:
            return ApiPremiumDeterminingFactorIdEnum.HailroofIndication;
        case FactorIdEnum.KilometerPerYearMotor:
            return ApiPremiumDeterminingFactorIdEnum.KilometerPerYearMotor;
        case FactorIdEnum.Content:
            return ApiPremiumDeterminingFactorIdEnum.Content;
        case FactorIdEnum.Strawroofing:
            return ApiPremiumDeterminingFactorIdEnum.Strawroofing;
        case FactorIdEnum.MonumentCode:
            return ApiPremiumDeterminingFactorIdEnum.MonumentCode;
        case FactorIdEnum.BuildYear:
            return ApiPremiumDeterminingFactorIdEnum.BuildYear;
        case FactorIdEnum.OwnRisk:
            return ApiPremiumDeterminingFactorIdEnum.OwnRisk;
        case FactorIdEnum.HomeType:
            return ApiPremiumDeterminingFactorIdEnum.HomeType;
        case FactorIdEnum.UserSurface:
            return ApiPremiumDeterminingFactorIdEnum.UserSurface;
        case FactorIdEnum.Security:
            return ApiPremiumDeterminingFactorIdEnum.Security;
        }
}
